import React from 'react';
import { APP_VERSION, IS_DEVELOPMENT } from '../utils/config';
import './HomePage.css';

const HomePage: React.FC = () => {
  return (
    <div className="page-container home-page">
      <img src="/images/me.jpg" alt="Matthew Dabit" className="profile-image" />

      <div className="home-content">
        {IS_DEVELOPMENT && <div className="dev-badge">Development Mode</div>}

        <div className="site-description">
          <h1>Welcome to My Portfolio</h1>
          <p>
            This site is meant to demonstrate a part of my capabilities in machine learning, backend
            development, and front end development. Feel free to explore the different projects and
            my resume to learn more about my skills and experience. This site is built using React,
            TypeScript, and FastAPI, and is deployed on AWS. The work demonstrated here is not
            inclusive of all that I am capable of, but I hope you find it interesting and useful.
            This site also does not contain all of my projects, you can find a full list of my
            public repositories on my GitHub profile, linked below. This is site is also mobile
            friendly, so feel free to explore it on your phone or tablet.
          </p>
        </div>

        <div className="about-me-section">
          <h2>About Me</h2>
          <p>
            I'm a San Francisco native and a passionate software engineer with a decade of
            experience, currently leading the risk team at Highnote, a fintech company I helped grow
            from zero customers to a $782 million valuation. A 2016 Berkeley graduate, I conducted
            neuroscience research and served as a lab assistant/tutor for CS61B, igniting my love
            for coding—a passion rooted in my childhood obsession with video games. My mantra,
            "Honor thy craft. Write software so consistently that your fingertips would drill holes
            into your keyboard," drives my work in building robust software systems.
          </p>
          <p>
            When I'm not coding, I'm cheering for my beloved San Francisco sports teams, especially
            the 49ers, or spending time with my loving wife, Valentina, and our two adorable cats,
            Haku and Taro.
          </p>
          <div className="family-images">
            <div className="image-container">
              <img src="/images/me2.jpg" alt="Matthew" className="family-image" />
              <p className="image-caption">Sister-in-law and I</p>
            </div>
            <div className="image-container">
              <img src="/images/wife.jpg" alt="Valentina" className="family-image" />
              <p className="image-caption">Valentina and I</p>
            </div>
            <div className="image-container">
              <img src="/images/haku.jpg" alt="Haku" className="family-image" />
              <p className="image-caption">Haku</p>
            </div>
            <div className="image-container">
              <img src="/images/taro.jpg" alt="Taro" className="family-image" />
              <p className="image-caption">Taro</p>
            </div>
          </div>
        </div>

        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="contact-details">
            <p>
              <strong>Phone:</strong> <a href="tel:415-627-7295">415-627-7295</a>
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:mattdabit@gmail.com">mattdabit@gmail.com</a>
            </p>
          </div>
          <div className="social-links">
            <a
              href="https://www.linkedin.com/in/mattdabit/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/mattdabit"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              GitHub
            </a>
          </div>
        </div>

        <div className="app-version">Version: {APP_VERSION}</div>
      </div>
    </div>
  );
};

export default HomePage;
